
<template>
    <div class="container_shop">
        <!-- <div class="shop_top_title">累计完成评价企业状态统计</div> -->
        <div class="shop_title line_bottom" @click="goBusinessList({ name: '总数', code: 'all', ind: 0,cityName:cityName})">
            <div class="title">
                <p>{{grogshopTitle}}(家)</p>
                <img src="../../../assets/image/inner_icon.png"/>
            </div>
            <p class="shop_total">{{formData.total}}</p>
        </div>
        <div class="shop_type line_bottom">
            <div class="shop_item" @click="goBusinessList({ name: '正常经营数', code: 'normal', ind: 0,cityName:cityName})">
                    <div class="shop_left"> 
                        <p>正常经营数(家)</p>
                        <!-- <p>未评数(家)</p> -->
                        <img src="../../../assets/image/inner_icon.png"/>
                    </div>
                    <p class="item_total">{{formData.normal}}</p>
            </div>
            <div class="shop_item" @click="goBusinessList({ name: '停业数', code: 'stop', ind: 0,cityName:cityName})">
                    <div class="shop_left">
                        <!-- <p>已评数(家)</p> -->
                        <p>停业数(家)</p>
                        <img src="../../../assets/image/inner_icon.png"/>
                    </div>
                    <p class="item_total">{{formData.stop}}</p>
            </div>
            <div class="shop_item" @click="goBusinessList({ name: '经营范围变更数', code: 'change', ind: 0,cityName:cityName})">
                    <div class="shop_left">
                        <p>经营范围变更数(家)</p>
                        <!-- <p>无法评分数(家)</p> -->
                        <img src="../../../assets/image/inner_icon.png"/>
                    </div>
                    <p class="item_total">{{ formData.businessChanged }}</p>
            </div>
        </div>
        <div class="item_list line_bottom" @click="goBusinessList({name: '', code: 'online', ind: 1})">
            <div class="c_total">
                    <p class="tip3">评分达标企业</p>
                    <div class="p_total">
                        <span>{{formData.online}}</span>
                        <span>家</span>
                    </div>
            </div>
            <p class="tip1">较上季度</p>
            <div class="complin">
                <p class="tip2" v-if="formData.pExponent === 0">持平</p>
                <p class="tip2" v-if="formData.pExponent > 0">+{{formData.pExponent}}</p>
                <p class="tip2" v-if="formData.pExponent < 0">{{formData.pExponent}}</p>
                <img class="iconSize" src="../../../assets/image/ic_cp@3x (1).png" alt="" v-if="formData.pExponent === 0">
                <img class="iconSize" src="../../../assets/image/ic_ss_b@3x.png" alt="" v-else-if="formData.pExponent > 0">
                <img class="iconSize" src="../../../assets/image/ic_xj_b@3x.png" alt="" v-else-if="formData.pExponent < 0">
            </div>
            <img src="../../../assets/image/inner_icon.png" class="arrow_right"/>
        </div>
        <div class="item_list line_bottom" @click="goBusinessList({name: '', code: 'supervision', ind: 2})">
            <div class="c_total">
                    <p class="tip3">重点关注名单</p>
                    <div class="p_total">
                        <span>{{formData.supervision}}</span>
                        <span>家</span>
                    </div>
            </div>
            <p class="tip1">较上季度</p>
            <div class="complin">
                <p class="tip2" style="color: #2283E6" v-if="formData.zExponent === 0">持平</p>
                <p class="tip2" style="color: #999999" v-if="formData.zExponent > 0">+{{formData.zExponent}}</p>
                <p class="tip2" style="color:#999999" v-if="formData.zExponent < 0">{{formData.zExponent}}</p>
                <img class="iconSize" src="../../../assets/image/ic_cp@3x (1).png" alt="" v-if="formData.zExponent === 0">
                <img class="iconSize" src="../../../assets/image/ic_ss_b@3x.png" alt="" v-else-if="formData.zExponent > 0">
                <img class="iconSize" src="../../../assets/image/ic_xj_b@3x.png" alt="" v-else-if="formData.zExponent < 0">
            </div>
            <img src="../../../assets/image/inner_icon.png" class="arrow_right"/>
        </div>
<!--        <div class="item_list " @click="goBusinessList({name: '', code: 'blacklist', ind: 3})">
            <div class="c_total">
                    <p class="tip3">黑名单</p>
                    <div class="p_total">
                        <span>{{formData.blacklist}}</span>
                        <span>家</span>
                    </div>
            </div>
            <p class="tip1">较上季度</p>
            <div class="complin">
                <p class="tip2" style="color: #2283E6" v-if="formData.hExponent === 0">持平</p>
                <p class="tip2" style="color: #999999" v-if="formData.hExponent > 0">+{{formData.hExponent}}</p>
                <p class="tip2" style="color:#999999" v-if="formData.hExponent < 0">{{formData.hExponent}}</p>
                <img class="iconSize" src="../../../assets/image/ic_cp@3x (1).png" alt="" v-if="formData.hExponent === 0">
                <img class="iconSize" src="../../../assets/image/ic_ss_b@3x.png" alt="" v-else-if="formData.hExponent > 0">
                <img class="iconSize" src="../../../assets/image/ic_xj_b@3x.png" alt="" v-else-if="formData.hExponent < 0">
            </div>
            <img src="../../../assets/image/inner_icon.png" class="arrow_right"/>
        </div>-->
        <!-- <div class="item_list line_bottom" @click="goBusinessList({name: '', code: 'noline', ind: 5})">
            <div class="c_total">
                    <p class="tip3">无法评分</p>
                    <div class="p_total">
                        <span>{{formData.stop}}</span>
                        <span>家</span>
                    </div>
            </div>
            <p class="tip1">较上季度</p>
            <div class="complin">
                <p class="tip2" style="color: #2283E6" v-if="formData.pExponent === 0">持平</p>
                <p class="tip2" style="color: #999999" v-if="formData.pExponent > 0">+{{formData.pExponent}}</p>
                <p class="tip2" style="color:#999999" v-if="formData.pExponent < 0">{{formData.pExponent}}</p>
                <img class="iconSize" src="../../../assets/image/ic_cp@3x (1).png" alt="" v-if="formData.pExponent === 0">
                <img class="iconSize" src="../../../assets/image/ic_ss_b@3x.png" alt="" v-else-if="formData.pExponent > 0">
                <img class="iconSize" src="../../../assets/image/ic_xj_b@3x.png" alt="" v-else-if="formData.pExponent < 0">
            </div>
            <img src="../../../assets/image/inner_icon.png" class="arrow_right"/>
        </div> -->
    </div>
</template>

<script>
    export default {
        props: {
            formData: {
                type: Object,
                default: null
            },
            grogshopTitle: {
                type: String,
                default: '累计完成评价总数'
            }
            // cityName: {
            //     type: String,
            //     default: ''
            // }
        },
        data () {
            return {
                total: '',
                cityName: ''
            }
        },
        computed: {
            userInfo () {
                return this.$store.state.integrity.userInfo;
            }
        },
        created () {
        },
        watch: {
            userInfo (val) {
                this.cityName = val.regionName;
            }
        },
        methods: {

            goBusinessList (dataList) {
                console.log('诚信');
                console.log(this.cityName);
                // this.$router.push({
                //     path: '/integrity/businessList',
                //     query: { type: JSON.stringify(dataList) }
                // });
                this.$router.push(`/integrity/businessList?name=${encodeURIComponent(dataList.name)}&code=${dataList.code}&ind=${dataList.ind}&cityName=${encodeURIComponent(dataList.cityName)}`)
            }

        }
    }
</script>

<style lang="less" scoped>
.container_shop{
    width:100%;
    padding-bottom: 10px;
    background-color: #fff;
    .shop_top_title {
        font-size: 18px;
        font-weight: 600;
        padding-top: 12px;
        margin: 8px 0 0 12px;
    }
    .shop_title{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding:24px 0;
        box-sizing: border-box;
        .title{
            display: flex;
            flex-direction: row;
            align-items: center;
            p{
                font-size:12px;
                color:#333;
            }
            img{
                width:12px;
                height:12px;
            }
        }
        .shop_total{
            font-size:32px;
            color:#36B374;
            font-weight: 700;
            margin-top:8px;
        }
    }
    .shop_type{
        width:100%;
        display: flex;
        flex-direction: row;
        padding:15px 0;
        box-sizing: border-box;
        .shop_item{
            width:50%;
            display: flex;
            flex-direction: column;
            align-items: center;
            .shop_left{
                display: flex;
                flex-direction: row;
                align-items: center;
                p{
                    font-size:12px;
                    color:#333;
                }
                img{
                    width:12px;
                    height:12px;
                }
            }
            .item_total{
                font-size:24px;
                color:#36B374;
                margin-top:8px;
                font-weight: 700;
            }
        }
    }
    .item_list{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding:16px;
        box-sizing: border-box;
        .c_total{
            width:150px;
            .tip3{
                font-size:12px;
                color:#333333;
            }
            .p_total{
                margin-top:8px;
                font-size: 0;
                span{
                    display: inline-block;
                }
                span:nth-child(1){
                    font-size:18px;
                    color:#333;
                    font-weight: 700;
                }
                span:nth-child(2){
                    font-size:12px;
                    color:#999;
                    margin-left:2px;
                }
            }
        }

        .tip1{
            color:#999;
            font-size:12px;
        }
        .complin{
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            width:50px;
            .tip2{
                color:#999;
                font-size:12px;
            }
            .iconSize{
                width:8px;
                height:12px;
                margin-left:9px;
            }
        }

        .arrow_right{
            width:12px;
            height:12px;
        }
    }
}
</style>
